
export const MOVIES_SEARCH = 'MOVIES_SEARCH';
export const MOVIES_FETCHING = 'MOVIES_FETCHING';
export const MOVIES_SUCCESS = 'MOVIES_SUCCESS';
export const MOVIES_FAILED = 'MOVIES_FAILED';
export const MOVIES_SORT = 'MOVIES_SORT';
export const MOVIES_SIMILAR = 'MOVIES_SIMILAR';
